import {Button, Modal} from "react-bootstrap";
import React, {FC} from "react";

interface ModalOnSignupProps {
  showHint: boolean,
  setShowedHint: any,
  setUnder13: any
}

const ModalOnSignup: FC<ModalOnSignupProps> = ({showHint, setShowedHint, setUnder13}) => {
  return (
    <Modal className="modal-signup" show={showHint} size="lg"
           aria-labelledby="contained-modal-title-vcenter"
           centered
    >
      <Modal.Header closeButton onClick={() => setShowedHint(true)}>
        <Modal.Title>
          <h4 className="text-center">Welcome to Villa!</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col py-2">
            <h6>
              You'll need a VR headset to use Villa as a consumer or an enterprise user. Currently we
              support Meta Quest 2 and above headsets (Quest 1 is no longer supported by Meta) and if you haven't done so yet, please install Villa now
              from <a href="https://www.oculus.com/experiences/app/4784171281624823" target="blank" rel="nopener"><span className="orange">the Quest store</span></a>.
              We also work with other headsets at scale, so if you're a large enterprise over 1K users and prefer different hardware
              email info@villa.rocks and we'll set you up.
            </h6>
          </div>
        </div>
        <div className="row">
          <div className="col py-2">
            <h6>
              Villa is the popular Metaverse terraforming platform in inspiring
              real world and imagined locations around the world, and is used by professionals, creators, and gamers for entertainment and work. Featured activities
              range from building Metaverses, flying and exploring, jetfighting and team bonding, standups, happy hours, roadmapping, design,
              offsites, NFT exhibits, proptech, in-app games, world travel over digital twins, and lots
              more. Villa offers DIY virtual worlds creation requiring no code or design skills! Simply search, choose,
              and spawn from thousands of 3D, 2D, music and more or drag and drop your own. Villa is like 'Discord meets Westworld' in VR, where you get to be the founder of your own thrilling virtual world, then host meetings in it.
              Explore worlds that others
              created, join networking events, or host your own meetings either privately inside your org, or publicly. We offer free tiers and trials, subscriptions, and in-app purchases.
            </h6>
          </div>
        </div>
        <div className="row">
          <div className="col py-2">
            <h6>
              Proceed to open your Metaverse by signing up with any email, or use a work email to associate with teammates from an org
              that already has an enterprise account. Need a companywide license? Email info@villa.rocks
            </h6>
          </div>
        </div>
        <div className="row">
          <div className="col text-center py-4">
            <Button
              size="lg"
              onClick={() => setUnder13(false)}
              variant="primary"
            >
              I am under<br/> 13 years of age
            </Button>
          </div>
          <div className="col text-center py-4">
            <Button
              size="lg"
              onClick={() => setShowedHint(false)}
              variant="primary"
            >
              I am at least<br/> 13 years of age or older
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalOnSignup;
